// Mock data for Mind to Master clone

export const navLinks = [
  { name: 'Features', href: '#features' },
  { name: 'Pricing', href: '#pricing' },
  { name: 'Reviews', href: '#reviews' },
  { name: 'FAQ', href: '#faq' },
];

export const stats = [
  { value: '50,000+', label: 'Active Students' },
  { value: '1.2M+', label: 'Tests Attempted' },
  { value: '4.9/5', label: 'User Rating' },
  { value: '98%', label: 'Success Rate' },
];

export const examCategories = [
  { name: 'SSC', series: '12+ Series', icon: 'GraduationCap' },
  { name: 'UPSC', series: '8+ Series', icon: 'Landmark' },
  { name: 'JEE', series: '10+ Series', icon: 'Atom' },
  { name: 'NEET', series: '9+ Series', icon: 'Stethoscope' },
  { name: 'Banking', series: '15+ Series', icon: 'Banknote' },
  { name: 'Railway', series: '7+ Series', icon: 'TrainFront' },
  { name: 'Defence', series: '11+ Series', icon: 'Shield' },
  { name: 'State PSC', series: '20+ Series', icon: 'Building2' },
];

export const features = [
  {
    icon: 'MonitorSmartphone',
    title: 'Real Exam Interface',
    desc: 'Practice on exact same screen layout used in actual exam centers',
  },
  {
    icon: 'BarChart3',
    title: 'Deep Analytics',
    desc: 'Track speed, accuracy, and weak spots with AI-powered insights',
  },
  {
    icon: 'Trophy',
    title: 'All India Ranking',
    desc: 'Compete with thousands of students and see your national standing',
  },
  {
    icon: 'BookOpen',
    title: 'Expert Solutions',
    desc: 'Detailed explanations for every question by subject experts',
  },
  {
    icon: 'FileText',
    title: 'Previous Year Papers',
    desc: 'Past 10 years papers with topic-wise breakdown',
  },
  {
    icon: 'Smartphone',
    title: 'Mobile Compatible',
    desc: 'Practice anytime, anywhere on any device',
  },
];

export const plans = [
  {
    id: 'test_basic',
    name: 'Basic Pass',
    subtitle: 'Choose any 1 test series after purchase',
    price: 499,
    oldPrice: 1499,
    discount: '67% OFF',
    slotsLeft: 23,
    totalSlots: 50,
    popular: false,
    features: [
      'Choose Your Exam After Purchase',
      'Instant Login Credentials via Email/SMS',
      'Access to 1 Premium Test Series',
      'Full Mock + Sectional Tests',
      'Topic-wise Tests + PYQ Vault',
      'Deep Analytics & Explanations',
      'AI-Powered Rank Predictor',
      '1 Year Validity',
      'Mobile & Desktop Access',
      'Detailed Performance Reports',
    ],
  },
  {
    id: 'test_premium',
    name: 'Premium Bundle Pass',
    subtitle: 'Access any exam, anytime - your choice!',
    price: 999,
    oldPrice: 50000,
    discount: '98% OFF',
    slotsLeft: 147,
    totalSlots: 200,
    popular: true,
    features: [
      'Choose ANY Exam After Purchase',
      'Instant Login Credentials via Email/SMS',
      'Access to 50+ Test Series',
      'All Government Exams Coverage',
      'Full Mock + Sectional Suite',
      'Topic-wise Tests + PYQ Vault',
      'Cross-Exam Pattern Learning',
      'AI-Powered Rank Predictor',
      'Deep Analytics & Explanations',
      'Priority Expert Support',
      '1 Year Validity',
      'Mobile & Desktop Access',
      'Free Lifetime Updates',
    ],
  },
];

export const steps = [
  {
    step: 'Step 1',
    icon: 'Award',
    title: 'Choose Your Pass',
    desc: 'Select Basic Pass (\u20B9499) for 1 test series or Premium Bundle (\u20B9999) for 50+ test series',
  },
  {
    step: 'Step 2',
    icon: 'Mail',
    title: 'Get Instant Access',
    desc: 'Receive login credentials via Email & SMS within 2-5 minutes of payment',
  },
  {
    step: 'Step 3',
    icon: 'Target',
    title: 'Select Your Exam',
    desc: 'Login to dashboard and choose any exam you want to prepare for (SSC, UPSC, Banking, etc.)',
  },
  {
    step: 'Step 4',
    icon: 'TrendingUp',
    title: 'Start Practicing',
    desc: 'Access unlimited tests for 1 year and track your progress with AI-powered analytics',
  },
];

export const testimonials = [
  {
    name: 'Priya Sharma',
    exam: 'SSC CGL 2024',
    result: 'AIR 127',
    avatar: 'https://images.unsplash.com/photo-1617009762269-c062aaf6b3a0?w=112&h=112&fit=crop&crop=faces&auto=format&q=70',
    text: 'Mind to Master ki test series ne meri preparation ko ek naya direction diya. Questions ki quality aur analysis bahut accurate hai.',
  },
  {
    name: 'Rahul Verma',
    exam: 'UPSC Prelims 2024',
    result: 'Qualified',
    avatar: 'https://images.unsplash.com/photo-1573999842765-26f179ec3979?w=112&h=112&fit=crop&crop=faces&auto=format&q=70',
    text: 'Premium bundle pass best investment hai. Maine sirf \u20B9999 mein 50+ test series access kar liye. Highly recommended!',
  },
  {
    name: 'Anjali Singh',
    exam: 'Banking PO 2024',
    result: 'Selected',
    avatar: 'https://images.pexels.com/photos/9159272/pexels-photo-9159272.jpeg?w=112&h=112&fit=crop&crop=faces&auto=compress',
    text: 'AI rank predictor ne mujhe consistently improve karne mein help ki. Test series ka pattern bilkul real exam jaisa hai.',
  },
  {
    name: 'Vikram Joshi',
    exam: 'JEE Mains 2024',
    result: '99.2 Percentile',
    avatar: 'https://images.pexels.com/photos/19186826/pexels-photo-19186826.jpeg?w=112&h=112&fit=crop&crop=faces&auto=compress',
    text: 'Topic-wise tests ne mere weak areas ko identify karne mein bahut help ki. Best test series platform!',
  },
];

export const faqs = [
  {
    q: 'Pass purchase karne ke baad test series kaise access karun?',
    a: 'Payment complete hote hi 2-5 minutes ke andar aapko Email aur SMS par login credentials mil jayenge. Dashboard par login karke aap apna exam choose kar sakte hain aur turant test series access kar sakte hain.',
  },
  {
    q: 'Kya main pehle exam choose karta hoon ya baad mein?',
    a: 'Aapko pehle exam choose karne ki zarurat NAHI hai. Pass purchase karne ke baad aapko instant login credentials milenge, aur phir aap apni dashboard se koi bhi exam select kar sakte hain.',
  },
  {
    q: 'Login credentials kitne time mein milte hain?',
    a: 'Payment successful hone ke 2 se 5 minutes ke andar aapko Email aur SMS par login credentials mil jate hain. Agar kabhi delay ho to WhatsApp support par contact karein.',
  },
  {
    q: 'Basic Pass aur Premium Bundle Pass mein kya difference hai?',
    a: 'Basic Pass (\u20B9499) mein aapko 1 test series ka access milta hai jise aap purchase ke baad choose kar sakte hain. Premium Bundle Pass (\u20B9999) mein aapko 50+ test series ka access milta hai jisme SSC, UPSC, Banking, Railway, Defence, JEE, NEET sabhi exams cover hote hain.',
  },
  {
    q: 'Pass ki validity kitni hai?',
    a: 'Dono pass ki validity 1 year hai. Purchase ki date se 365 days tak aap unlimited tests attempt kar sakte hain, analytics dekh sakte hain, aur apni preparation track kar sakte hain.',
  },
  {
    q: 'Kya main mobile se bhi tests de sakta hun?',
    a: 'Bilkul! Hamara platform completely mobile compatible hai. Aap Android, iOS, tablet ya desktop kisi bhi device se tests de sakte hain. Interface real exam center jaisa hi hota hai.',
  },
];

export const purchaseNotifications = [
  { name: 'Amit K.', city: 'Delhi', plan: 'Premium Pass', time: '2 min ago' },
  { name: 'Sneha M.', city: 'Mumbai', plan: 'Basic Pass', time: '5 min ago' },
  { name: 'Rohit S.', city: 'Bangalore', plan: 'Premium Pass', time: '8 min ago' },
  { name: 'Kavya P.', city: 'Hyderabad', plan: 'Basic Pass', time: '12 min ago' },
  { name: 'Arjun T.', city: 'Chennai', plan: 'Premium Pass', time: '15 min ago' },
  { name: 'Neha G.', city: 'Pune', plan: 'Basic Pass', time: '18 min ago' },
  { name: 'Vikash R.', city: 'Kolkata', plan: 'Premium Pass', time: '22 min ago' },
];
